// extracted by mini-css-extract-plugin
export var about = "styles-module--about--zKAIE";
export var description = "styles-module--description--JXLDz";
export var name = "styles-module--name--jS0xr";
export var picture = "styles-module--picture--3n9jM";
export var product = "styles-module--product--Ace3Q";
export var solutions = "styles-module--solutions--tbbri";